webpackJsonp([17],{

/***/ 2720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _signup_controller = __webpack_require__(2721);

var _signup_controller2 = _interopRequireDefault(_signup_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var isLicensed = license && license.IsLicensed === 'true';
    var enableOpenServer = config.EnableOpenServer === 'true';
    var noAccounts = config.NoAccounts === 'true';
    var enableSignUpWithEmail = config.EnableSignUpWithEmail === 'true';
    var enableSignUpWithGitLab = config.EnableSignUpWithGitLab === 'true';
    var enableSignUpWithGoogle = config.EnableSignUpWithGoogle === 'true';
    var enableSignUpWithOffice365 = config.EnableSignUpWithOffice365 === 'true';
    var enableLDAP = config.EnableLdap === 'true';
    var enableSAML = config.EnableSaml === 'true';
    var samlLoginButtonText = config.SamlLoginButtonText;
    var siteName = config.SiteName;

    return {
        isLicensed: isLicensed,
        enableOpenServer: enableOpenServer,
        noAccounts: noAccounts,
        enableSignUpWithEmail: enableSignUpWithEmail,
        enableSignUpWithGitLab: enableSignUpWithGitLab,
        enableSignUpWithGoogle: enableSignUpWithGoogle,
        enableSignUpWithOffice365: enableSignUpWithOffice365,
        enableLDAP: enableLDAP,
        enableSAML: enableSAML,
        samlLoginButtonText: samlLoginButtonText,
        siteName: siteName
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_signup_controller2.default);

/***/ }),

/***/ 2721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _client = __webpack_require__(270);

var _browser_history = __webpack_require__(273);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_actions = __webpack_require__(832);

var _user_actions = __webpack_require__(781);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

var _announcement_bar = __webpack_require__(882);

var _announcement_bar2 = _interopRequireDefault(_announcement_bar);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _constants = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignupController = function (_React$Component) {
    (0, _inherits3.default)(SignupController, _React$Component);

    function SignupController(props) {
        (0, _classCallCheck3.default)(this, SignupController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignupController.__proto__ || (0, _getPrototypeOf2.default)(SignupController)).call(this, props));

        _initialiseProps.call(_this);

        _this.renderSignupControls = _this.renderSignupControls.bind(_this);

        var loading = false;
        var serverError = '';
        var noOpenServerError = false;
        var usedBefore = false;

        if (_this.props.location.search) {
            var params = new URLSearchParams(_this.props.location.search);
            var hash = params.get('h');
            if (hash == null) {
                hash = '';
            }
            var inviteId = params.get('id');
            if (inviteId == null) {
                inviteId = '';
            }

            if (inviteId) {
                loading = true;
            } else if (hash && !_user_store2.default.getCurrentUser()) {
                usedBefore = _browser_store2.default.getGlobalItem(hash);
            } else if (!inviteId && !_this.props.enableOpenServer && !_this.props.noAccounts) {
                noOpenServerError = true;
                serverError = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'signup_user_completed.no_open_server',
                    defaultMessage: 'This server does not allow open signups.  Please speak with your Administrator to receive an invitation.'
                });
            }
        }

        _this.state = {
            loading: loading,
            serverError: serverError,
            noOpenServerError: noOpenServerError,
            usedBefore: usedBefore
        };
        return _this;
    }

    (0, _createClass3.default)(SignupController, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _browser_store2.default.removeGlobalItem('team');
            if (this.props.location.search) {
                var params = new URLSearchParams(this.props.location.search);
                var hash = params.get('h') || '';
                var data = params.get('d') || '';
                var inviteId = params.get('id') || '';

                var userLoggedIn = _user_store2.default.getCurrentUser() != null;

                if ((inviteId || hash) && userLoggedIn) {
                    (0, _team_actions.addUserToTeamFromInvite)(data, hash, inviteId, function (team) {
                        (0, _user_actions.loadMe)().then(function () {
                            _browser_history.browserHistory.push('/' + team.name + ('/channels/' + _constants.Constants.DEFAULT_CHANNEL));
                        });
                    }, this.handleInvalidInvite);

                    return;
                }

                if (inviteId) {
                    (0, _team_actions.getInviteInfo)(inviteId, function (inviteData) {
                        if (!inviteData) {
                            return;
                        }

                        _this2.setState({ // eslint-disable-line react/no-did-mount-set-state
                            serverError: '',
                            loading: false
                        });
                    }, this.handleInvalidInvite);

                    return;
                }

                if (userLoggedIn) {
                    GlobalActions.redirectUserToDefaultTeam();
                }
            }
        }
    }, {
        key: 'renderSignupControls',
        value: function renderSignupControls() {
            var signupControls = [];

            if (this.props.enableSignUpWithEmail) {
                signupControls.push(_react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        className: 'btn btn-custom-login btn--full email',
                        key: 'email',
                        to: '/signup_email' + window.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon fa fa-envelope' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'signup.email',
                            defaultMessage: 'Email and Password'
                        })
                    )
                ));
            }

            if (this.props.enableSignUpWithGitLab) {
                signupControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login btn--full gitlab',
                        key: 'gitlab',
                        href: _client.Client4.getOAuthRoute() + '/gitlab/signup' + window.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup.gitlab',
                                defaultMessage: 'GitLab Single Sign-On'
                            })
                        )
                    )
                ));
            }

            if (this.props.isLicensed && this.props.enableSignUpWithGoogle) {
                signupControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login btn--full google',
                        key: 'google',
                        href: _client.Client4.getOAuthRoute() + '/google/signup' + window.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup.google',
                                defaultMessage: 'Google Account'
                            })
                        )
                    )
                ));
            }

            if (this.props.isLicensed && this.props.enableSignUpWithOffice365) {
                signupControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login btn--full office365',
                        key: 'office365',
                        href: _client.Client4.getOAuthRoute() + '/office365/signup' + window.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup.office365',
                                defaultMessage: 'Office 365'
                            })
                        )
                    )
                ));
            }

            if (this.props.isLicensed && this.props.enableLDAP) {
                signupControls.push(_react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        className: 'btn btn-custom-login btn--full ldap',
                        key: 'ldap',
                        to: '/signup_ldap' + window.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon fa fa-folder-open fa--margin-top' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup.ldap',
                                defaultMessage: 'AD/LDAP Credentials'
                            })
                        )
                    )
                ));
            }

            if (this.props.isLicensed && this.props.enableSAML) {
                var query = '';
                if (window.location.search) {
                    query = '&action=signup';
                } else {
                    query = '?action=signup';
                }

                signupControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login btn--full saml',
                        key: 'saml',
                        href: '/login/sso/saml' + window.location.search + query
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon fa fa-lock fa--margin-top' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            this.props.samlLoginButtonText
                        )
                    )
                ));
            }

            if (signupControls.length === 0) {
                var signupDisabledError = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'signup_user_completed.none',
                    defaultMessage: 'No user creation method has been enabled. Please contact an administrator for access.'
                });
                signupControls = _react2.default.createElement(_form_error2.default, {
                    error: signupDisabledError,
                    margin: true
                });
            } else if (signupControls.length === 1) {
                if (this.props.enableSignUpWithEmail) {
                    return _browser_history.browserHistory.push('/signup_email' + window.location.search);
                } else if (this.props.isLicensed && this.props.enableLDAP) {
                    return _browser_history.browserHistory.push('/signup_ldap' + window.location.search);
                }
            }

            return signupControls;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.loading) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            if (this.state.usedBefore) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'signup_user_completed.expired',
                        defaultMessage: 'You\'ve already completed the signup process for this invitation or this invitation has expired.'
                    })
                );
            }

            var serverError = null;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            var signupControls = void 0;
            if (this.state.noOpenServerError || this.state.usedBefore) {
                signupControls = null;
            } else {
                signupControls = this.renderSignupControls();
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_announcement_bar2.default, null),
                _react2.default.createElement(_back_button2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container' },
                        _react2.default.createElement('img', {
                            className: 'signup-team-logo',
                            src: _logo2.default
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'signup__content' },
                            _react2.default.createElement(
                                'h1',
                                null,
                                this.props.siteName
                            ),
                            _react2.default.createElement(
                                'h4',
                                { className: 'color--light' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'web.root.signup_info'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'margin--extra' },
                                _react2.default.createElement(
                                    'h5',
                                    null,
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'signup.title',
                                            defaultMessage: 'Create an account with:'
                                        })
                                    )
                                )
                            ),
                            signupControls,
                            serverError
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'color--light' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup_user_completed.haveAccount',
                                defaultMessage: 'Already have an account?'
                            }),
                            ' ',
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    to: '/login' + this.props.location.search
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'signup_user_completed.signIn',
                                    defaultMessage: 'Click here to sign in.'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SignupController;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleInvalidInvite = function (err) {
        var serverError = void 0;
        if (err.server_error_id === 'store.sql_user.save.max_accounts.app_error') {
            serverError = err.message;
        } else {
            serverError = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'signup_user_completed.invalid_invite',
                defaultMessage: 'The invite link was invalid.  Please speak with your Administrator to receive an invitation.'
            });
        }

        _this3.setState({
            noOpenServerError: true,
            loading: false,
            serverError: serverError
        });
    };
};

exports.default = SignupController;


SignupController.propTypes = {
    location: _propTypes2.default.object,
    isLicensed: _propTypes2.default.bool.isRequired,
    enableOpenServer: _propTypes2.default.bool.isRequired,
    noAccounts: _propTypes2.default.bool.isRequired,
    enableSignUpWithEmail: _propTypes2.default.bool.isRequired,
    enableSignUpWithGitLab: _propTypes2.default.bool.isRequired,
    enableSignUpWithGoogle: _propTypes2.default.bool.isRequired,
    enableSignUpWithOffice365: _propTypes2.default.bool.isRequired,
    enableLDAP: _propTypes2.default.bool.isRequired,
    enableSAML: _propTypes2.default.bool.isRequired,
    samlLoginButtonText: _propTypes2.default.string,
    siteName: _propTypes2.default.string
};

/***/ })

});


// WEBPACK FOOTER //
// 17.c3d3e22e48b3c93b7338.js